/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LassiApplication {
  LASSI = 'LASSI',
  VMT = 'VMT',
  OHAP = 'OHAP',
  TPC = 'TPC',
  SPEAR = 'SPEAR',
}
